import { Common } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

const NUMBER_MAP = new Map([
    [2, 'Second'],
    [3, 'Third'],
    [4, 'Fourth'],
    [5, 'Fifth'],
    [6, 'Sixth'],
    [7, 'Seventh'],
    [8, 'Eighth'],
    [9, 'Ninth'],
    [10, 'Tenth'],
]);

export const mapErrorLabel = (common: Common, message: string, failedLoginLimit?: number | null): string => {
    const language = LanguagesState.get(common);
    const config = ConfigComponents.get(common);

    const messageTxt = language.getTranslation('login.error.suspended-account', 'Your account is suspended');

    if (message === 'Invalid username or password') {
        return language.getTranslation(
            'login.error.invalid-username-or-password',
            'Looks like you are having some issues with login! Try again or use the Forgot password for help. {failedLoginLimit} failed attempt will suspend your account.',
            { failedLoginLimit: NUMBER_MAP.get(failedLoginLimit ?? 3) ?? '' }
        );
    }

    if (message === 'Account status: suspended - too many attempts') {
        return language.getTranslation(
            'login.error.invalid-username-or-password.to-many-attempts',
            'Your account has been suspended for security reasons. Please contact Customer Support at {accountHelperMail}',
            { accountHelperMail: config.config.accountHelperMail }
        );
    }

    if (message === 'Account status: suspended') {
        return messageTxt;
    }

    if (message === 'Account status: blocked') {
        return messageTxt;
    }

    if (message === 'Account status: closed') {
        return messageTxt;
    }

    if (message === 'GamStop validation failed') {
        return messageTxt;
    }

    if (message.includes('Blocked by SelfExclusion')) {
        return language.getTranslation('errors.account-self-excluded', 'Your account is self excluded');
    }

    if (message.includes('blocked') && message.includes('Previously Positive')) {
        return language.getTranslation(
            'errors.account-previously-positive',
            'Your account is blocked due to being previously Gamstoped. For more information contact our Customer Service {accountHelperMail}',
            { accountHelperMail: config.config.accountHelperMail }
        );
    }

    return message;
};
